module.exports = __webpack_public_path__ + "static/img/coming-soon.67d1d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/coming-soon.png
// module id = wPnU
// module chunks = 150